import React,{useState,useEffect,useContext,useMemo,useRef} from "react";
import studylistContext from "../../context/studylist/StudylistContext";
import LoadingBar from "react-top-loading-bar";
import { CSSTransition, Transition } from "react-transition-group";
import {
  PaginationState,
  useReactTable,
  getCoreRowModel,
  ColumnDef,
  flexRender,
  getExpandedRowModel,
  createRow,
  expandRows,
  RowSelection,
} from "@tanstack/react-table";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
  useInfiniteQuery
} from "react-query";
import { t } from "i18next";
import { USERTYPES } from "../../constants/Constants";
import MobileListComponent from "../../pages/StudyList/components/MobileListComponent";
import { useInView } from 'react-intersection-observer';
import { Spinner, SpinnerSize } from "@fluentui/react";
import studyReportContext from "../../context/studyreport/StudyReportContext";

const MobileStudyListTable = (props) => {
  const { ref, inView, entry } = useInView({
    /* Optional options */
    threshold: 0.5,
  });
  const [isIntersecting, setIsIntersecting] = useState(false);
  const [allowAddingRows, setAllowAddingRows] = useState(false);
  const bottomRef = useRef();
  const tbodyRef = useRef(null);
    const {
        filterInputValues,
        showCount,
        setShowCount,
        refreshRequired,
        setRefreshRequired,
        storedRows,
        setStoredRows,
        studyListLoading,
        setStudyListLoading,
        studyListRef,
        dataQueryState,
        setDataQueryState,
        updateLockUnlockRows,
        setUpdateLockUnlockRows,
        setSearchResultLength,
        menuItemsForBatchAndInference,
        rowSelectionState,
        setRowSelectionState,
        setRowSelectedArray,
        rowSelectedArray,
        getCountOfAbleToDeleteStudies,
        handleBatchReInference,
        batchReinferenceAndDeleteArray,
        resetRowSelection,
        setResetRowSelection,
        handleBatchDelete,
        unreportedAllTabs,
        fetchData,
        fetchDataMobile,
        setFirstTimeLoading,
        filterApplied,
        allDataElement, setAllDataElement,
        searchResultLength,
        handleChangeSizeIndex,
        sortGlobal,
        paginationObj,
        setFilterApplied
      } = useContext(studylistContext);

      const { setAlertSuccessModal, alertSuccessModal} = useContext(studyReportContext);

      const queryClient = useQueryClient();

      const [rowSelection, setRowSelection] = useState({});
      const defaultData = useMemo(() => [], []);
      const [expanded, setExpanded] = useState({});
      const id = props.id;
      const sortObj = props.sortObj;
      const pageObj = props.pageObj;
      const filterObj = props.filterObj;
      const pageIndexFromParent = paginationObj[props.id].pageIndex;
      const [nextPageIndex,setNextPageIndex] = useState(1);
      
      const [showPullRefreshLoader, setShowPullRefreshLoader] = useState(false); 

      const [{ pageIndex, pageSize }, setPagination] = useState({
        pageIndex: props.pageObj.pageIndex,
        pageSize: props.pageObj.pageSize,
      });

      const pagination = useMemo(
        () => ({
          pageIndex,
          pageSize,
        }),
        [pageIndex, pageSize]
      );

      const fetchDataOptions = {
        pageIndex: pageIndexFromParent,
        showCount,
        pageSize,
        sortObj,
        id,
        filterObj: filterApplied,
        //refreshRequired
      };


      // const {
      //   data,
      //   status,
      //   error,
      //   fetchNextPage,
      //   isFetchingNextPage,
      //   isFetching,
      //   isFetched,
      //   hasNextPage
      // } = useInfiniteQuery({
      //   queryKey: [fetchDataOptions],
      //   queryFn: ({ pageParam }) => {
      //      if(newPageIndex != 0)
      //       return fetchDataMobile({ options: fetchDataOptions, pageParams: pageIndexFromParent, temp: pageParam })
          
      //   }, 
      //   initialPageParam: 0,
      //   getNextPageParam: (lastPage, allPages) => {
      //     console.log("--- Get Param calling---")
      //     // const nextPage =  allPages.length + 1 ;
      //     // return nextPage;
      //   },
      //   keepPreviousData: true,
      //   staleTime: Infinity,
      //   cacheTime: 15 * 60 * 1000,
      //   initialData: () => {
      //     return queryClient.getQueryData(['data']);
      //   },
      //   initialDataUpdatedAt: () =>
      //     queryClient.getQueryState(['data'])?.dataUpdatedAt,
      // });

      const dataQuery = useQuery(
        ["data", fetchDataOptions],
        () => fetchDataMobile(fetchDataOptions),
        {
          keepPreviousData: true,
          staleTime: Infinity, // Set stale time to 5 minutes
          cacheTime: 15 * 60 * 1000, // Set cache time to 5 minutes
          initialData: () => {
            return queryClient.getQueryData(["data"]);
          },
          initialDataUpdatedAt: () =>
            queryClient.getQueryState(["data"])?.dataUpdatedAt,
        }
      );

      // useEffect(() => {
      //  if(dataQuery != undefined){
      //   // const formattedData = data?.pages.reduce((acc, page) => [...acc, ...page], []);
      //   //  console.log("--- Fetch Data ----",data,data.pages);
      //   if (isFetched && dataQuery != undefined) {
      //     let dataArray = allDataElement;
      //     console.log("---Page Index---",props.pageObj.pageIndex);
      //     if(props.pageObj.pageIndex >= 1){
      //       dataArray = [...dataArray, ...data.pages[0].rows];
      //     }else{
      //       if (tbodyRef?.current) {
      //         // console.log("--- Tbody ---",tbodyRef?.current?.scrollTop);
      //         if(tbodyRef?.current?.scrollTop != null && tbodyRef?.current?.scrollTop != undefined){
      //           tbodyRef.current.scrollTop = 0;
      //         }
      //       }
      //      dataArray = data.pages[0].rows;
      //     }
      //     console.log("--- Setting Data ---",dataArray);
      //     setFirstTimeLoading(false);
      //     setAllDataElement(dataArray);
      //   }
      //  }
        
      // }, [isFetched,isFetching]);

      useEffect(()=>{

      },[props.id])

      useEffect(()=>{
        if( pageIndex > 0 && searchResultLength <= 0){
          // console.log("---- Use Effect Running ----",searchResultLength,props.pageIndex);
          let tempPaginationObj = {
            pageIndex : pagination.pageIndex - 1,
            pageSize : pagination.pageSize
          };
          
          setPagination(tempPaginationObj)
  
          setAlertSuccessModal(()=>{
            const newItem = {...alertSuccessModal};
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = t("string-literals.no-more-pages");
            return newItem;
          });
        }
    },[searchResultLength])

      useEffect(() => {
        if (inView && !dataQuery.isFetching && dataQuery.isFetched) {
           console.log("--- Fetching next ----",pageIndexFromParent+1,dataQueryState,ref);
           if(dataQueryState?.data?.rows.length > 8){
            setAllowAddingRows(true);
            handleChangeSizeIndex(pageIndexFromParent+1, pageSize, props.id);
           }
           
          // fetchNextPage();
        }
      }, [inView]);

      useEffect(() => {
        console.log("--DataQueryState--",dataQueryState);
      }, [dataQueryState]);

      // useEffect(() => {
      //   // console.log("DATA QUERY")
      //   // console.log(dataQuery)
      //   if (isFetched) {
      //     setFirstTimeLoading(false);
      //     let dataQuery = {data: data?.pages[0]}
      //     // setDataQueryState(dataQuery);
      //     // props.setDataQueryParent(dataQuery);
      //   }
      // }, [isFetched, isFetching]);


      useEffect(()=>{
        // console.log("--- Data ----",dataQueryState,data);
      },[dataQueryState])
      

      const mobileColumns = useMemo(
        () => [
          {
            id: "patientDetails",
            show: true,
            accessorFn: (row) => row.id,
            accessorKey: "patientDetails",
            cell: (info) => <MobileListComponent data={info} roles={props.roles} tabId = {props.id} />,
            header: () => (
              <span className="study-list-header-txt">{t("study-list.column.patient-details")}</span>
            ),
            footer: (props) => props.column.id,
          },
        ],
        []
      );

      useEffect(() => {
        props.handleChangeSizeIndex(pageIndex, pageSize, props.id);
      }, [pageIndex, pageSize]);

      useEffect(() => {
        if (dataQuery != undefined && dataQuery != null && dataQuery.isFetched) {
          console.log("--- Tab change ---", dataQuery);
          setSearchResultLength(dataQuery?.data?.rows?.length);
          // props.setDataQueryParent(dataQuery);
          // if(pageIndexFromParent > 0){
          //   handleUpdateDataQuery();
          // }else{
          //   setDataQueryState(dataQuery);
          // }
        }
      }, [props.id]);

      useEffect(() => {
        if (dataQuery.isFetched) {
          setFirstTimeLoading(false);
          setShowPullRefreshLoader(false);
          // console.log("---Making False---",dataQuery,paginationObj[props.id]);
          setRefreshRequired(() => {
            const newItem = { ...refreshRequired };
            newItem[props.id].alreadyLoaded = true;
            return newItem;
          });
          props.setDataQueryParent(dataQuery);
          if(paginationObj[props.id].pageIndex > 0 && allowAddingRows){
            handleUpdateDataQuery();
          }else{
            setDataQueryState(dataQuery);
          }
          
          
        }
      }, [dataQuery.isFetched, dataQuery.isFetching]);

      useEffect(() => {
        // console.log("--- Refresh Required Data -----",refreshRequired);
        if (refreshRequired !== null && refreshRequired[props.id].alreadyLoaded == false) {
          dataQuery.refetch();
        }
      }, [refreshRequired]);
    
      useEffect(() => {
        if (refreshRequired[props.id].alreadyLoaded == false) {
          setTimeout(() => {
            dataQuery.refetch();
          }, 10);
        }
      }, [props.id]);

      const handleUpdateDataQuery = () => {
        dataQueryState.data.rows = dataQueryState?.data?.rows.concat(dataQuery?.data?.rows);
        console.log("--New Data--",dataQueryState);
        setDataQueryState(dataQueryState);
      }
    
      useEffect(() => {
        setPagination({ pageIndex: pageIndexFromParent, pageSize: pageSize });
      }, [pageIndexFromParent]);

     useEffect(()=>{
        setAllowAddingRows(false);
        handleChangeSizeIndex(0,pageSize,props.id);
        if(pageIndexFromParent != 0){
          setTimeout(() => {
            let filterUpdated = filterApplied + 1;
            setFilterApplied(filterUpdated);
          }, 200);
        }
     },[props.id])




      const table = useReactTable({
        data: dataQueryState?.data?.rows ?? defaultData,
        columns: mobileColumns,
        pageCount: dataQueryState?.data?.pageCount ?? -1,
        state: {
          pagination,
          rowSelection,
          expanded,
        },
        onPaginationChange: setPagination,
        onRowSelectionChange: setRowSelection,
        getCoreRowModel: getCoreRowModel(),
        // getExpandedRowModel: getExpandedRowModel,
        // getExpandedRowModel: (row) => fetchPriorsData(row),
        onExpandedChange: setExpanded,
        manualPagination: true,
        manualExpanding: true,
        meta: {
          // removeRowFromStudyList: (studyId) => {
          //   let newData = dataQueryState?.data?.rows.filter(
          //     (row) => row.id !== studyId
          //   );
          //   updateDataQueryState(newData);
          // },
          // updateTriageDetailFromStudyList: (studyId, maxAiEmergency) => {
          //   let newTriageDetails = dataQueryState?.data?.rows.map((row) =>{
          //     return row.id === studyId ? {...row, aiEmergencyMax:maxAiEmergency} : row;
          //   });
          //   updateDataQueryState(newTriageDetails);
          // },
        },
        // getPaginationRowModel: getPaginationRowModel(), // If only doing manual pagination, you don't need this
        debugTable: true,
      });

      const spinnerStyle = {
        circle: {
          height: "50px",
          width: "50px",
          borderWidth: "5px",
        }
      }

      // useEffect(()=>{
      //   console.log("--- Status ----",status);
      // },[status]);
    
      const openStudy = (row, dataQueryState) => {
        console.log("--- Row clicked ---",row);
        let url = "";
          url =
            "/new/study/load/" +
            row.original.id +
            "?firmId=" +
            row.original.assignmentList[0].firmId;
          // window.open("new/study/load/" + row.original.id+"?firmId=" + row.original.assignmentList[0].firmId);
        
        window.open(url, "_blank")
      };

      let touchStartY = 0;

      const handleTouchEnd = (event) => {
        console.log("--touchStartY--", touchStartY);
        const topRow = document.getElementsByClassName("mobile-top-row")[0]; // Get the first element with class "mobile-top-row"
        if (event?.changedTouches != null && topRow) {
          const touchEndY = event.changedTouches[0].clientY; // Get the final touch position
          const deltaY = touchEndY - touchStartY; // Calculate the vertical distance traveled
      
          // Define the threshold for pull-to-refresh
          const refreshThreshold = 100;
      
          // Check if the top row is visible in the current view
          const topRowRect = topRow.getBoundingClientRect();
          const isTopRowVisible = topRowRect.top >= 0 && topRowRect.bottom <= window.innerHeight;
          console.log("cal->",deltaY," ",refreshThreshold);
          if (deltaY > refreshThreshold && isTopRowVisible) {
            console.log("toprow->",topRow);
            // If the user has pulled down beyond the threshold and the top row is visible, trigger the refresh action
            console.log("Refresh required");
            setShowPullRefreshLoader(true);
            setAllowAddingRows(false);
            handleChangeSizeIndex(0,pageSize,props.id);
              setTimeout(() => {
                let filterUpdated = filterApplied + 1;
                setFilterApplied(filterUpdated);
              }, 200);
            
          }
        }
      };

    const handleTouchStart = (event) => {
      touchStartY = event.touches[0].clientY; // Store the initial touch position
    };
    
    const handleScroll = (ev) => {

    }


    return (<>
    <div ref={tbodyRef} className="studylist-mobile-table-container mobile-modal-scroll"
      onScroll={(event) => handleScroll(event)}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
        <div
          style={{
            padding: "auto",
            height: "100%",
            width: "100%",
            zIndex: "99999",
            display: `${studyListLoading ? "flex" : "none"}`,
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "black",
            opacity: "0.4",
            position: "absolute",
            top: "0",
            left: "0",
          }}
        >
          <LoadingBar
            ref={studyListRef}
            color="#0085FF"
            height={5}
            // progress={progress}
            onLoaderFinished={() => setStudyListLoading(false)}
            containerStyle={{
              backgroundColor: "black",
              opacity: "0.8",
              position: "absolute",
              top: "0",
              left: "0",
            }}
            loaderSpeed={1000}
            transitionTime={1000}
          />
        </div>
      
        {showPullRefreshLoader && <div className={`mobile-studylist-top-spinner ${showPullRefreshLoader?"show":""}`}><Spinner size={SpinnerSize.large} styles={spinnerStyle}/></div>}
        <table style={{ width: "100%" }}>
          <tbody >
            {table.getRowModel().rows.map((row, index) => {
              return (
                <React.Fragment key={index}>
                  <tr key={index}  className={`study-table-tr cursor-pointer ${index==0?" mobile-top-row":""}  ${
                          index % 2 == 0
                            ? "tr-alternative-color"
                            : "tr-second-alternative-color"
                        }`}>
                    {row.getVisibleCells().map((cell, index) => {
                      return (
                        <React.Fragment key={index}>
                          {cell.column.columnDef.show == true && (
                            <td
                              onClick={(event) => {
                                if (props.roles[0] != USERTYPES.FIRMTECHNICIAN)
                                openStudy(row);
                                }}
                              className="study-mobile-table-td"
                              key={index}
                            >
                              {flexRender(
                                cell.column.columnDef.cell,
                                cell.getContext()
                              )}
                            </td>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tr>
                  {row.getIsExpanded()
                    ? row.subRows.map((subRow, row_index) => {
                        return (
                          <CSSTransition
                            key={index}
                            timeout={500}
                            classNames="fade"
                          >
                            <tr
                              key={row_index}
                              className="study-table-tr cursor-pointer"
                              style={{ transition: "1s ease-in-out" }}
                              onDoubleClick={() => {
                                if (props.roles[0] != USERTYPES.FIRMTECHNICIAN)
                                  window.open(
                                    "new/study/load/" + row.original.id
                                  );
                              }}
                            >
                              {subRow
                                .getVisibleCells()
                                .map((cell, col_index) => {
                                  return (
                                    <td
                                      className="study-mobile-table-td"
                                      key={col_index}
                                      style={{
                                        backgroundColor: "#0d0d0d",
                                        borderTopLeftRadius: `${
                                          row_index === 0 && col_index === 0
                                            ? "10px"
                                            : "0px"
                                        }`,
                                        borderBottomLeftRadius: `${
                                          row_index ===
                                            row.subRows.length - 1 &&
                                          col_index === 0
                                            ? "10px"
                                            : "0px"
                                        }`,
                                        borderTopRightRadius: `${
                                          row_index === 0 &&
                                          col_index ===
                                            subRow.getVisibleCells().length - 1
                                            ? "10px"
                                            : "0px"
                                        }`,
                                        borderBottomRightRadius: `${
                                          row_index ===
                                            row.subRows.length - 1 &&
                                          col_index ===
                                            subRow.getVisibleCells().length - 1
                                            ? "10px"
                                            : "0px"
                                        }`,
                                      }}
                                    >
                                      {flexRender(
                                        cell.column.columnDef.cell,
                                        cell.getContext()
                                      )}
                                    </td>
                                  );
                                })}
                            </tr>
                          </CSSTransition>
                        );
                      })
                    : null}
                </React.Fragment>
              );
            })}
            {dataQuery?.data?.rows?.length > 0 && <tr ref={ref} style={{height:'60px'}}>{dataQuery.isFetching && <td ><Spinner size={SpinnerSize.large} styles={spinnerStyle}/></td>}</tr>}
            
          </tbody>
          {dataQueryState?.data?.rows?.length == 0 && dataQuery.isFetched && !dataQuery.isFetching && (
                <tbody style={{ verticalAlign: "top" }}>
                  <tr>
                    <td>
                      <div className="study-list-spinner study-list-mobile-empty-studies">
                        <span className="study-list-no-data-txt">
                        {t("study-list.messages.no-result-found")}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              )}
        </table>
      </div>
    </>)
}

export default MobileStudyListTable;